"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/TabMenu.css");
require("../styles/Tab.css");
var React = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _dist = require("package_ui_ihm/dist");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : TableMenuRD.js
* Description : Ce fichier contient la définition du composant TableMenuRD 
*               Ce composant est un menu déroulant avec des liens pour naviguer sur l'application coté R&D
* Date de création : 20 février 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* TableMenuRD : ce composant est un menu déroulant avec des liens pour naviguer sur l'application
*
* Type : composant 
*
* Parametres : 
*  - children -- contient l'élément à afficher quand le menu est fermé 
*  - classCss -- contient la classe CSS à appliquer au menu 
*/
function TabMenuRD(_ref) {
  var children = _ref.children,
    classCss = _ref.classCss;
  // Define useState hooks and variable
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchor = _React$useState2[0],
    setAnchor = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    menuWidth = _React$useState4[0],
    setMenuWidth = _React$useState4[1];
  var open = Boolean(anchor);

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    currentUser = _useAuth.currentUser;
  var navigate = (0, _reactRouterDom.useNavigate)();

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  var handleClick = function handleClick(event) {
    setAnchor(event.currentTarget);
    if (screenWidth > 650) {
      setMenuWidth(event.currentTarget.clientWidth - 15); // Récupère la largeur du bouton
    } else {
      setMenuWidth(event.currentTarget.clientWidth + 50); // Récupère la largeur du bouton
    }
  };
  var handleClose = function handleClose() {
    setAnchor(null);
  };
  var handleLink = function handleLink(event, path) {
    event.preventDefault();
    handleClose();
    navigate(path);
  };

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classCss,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"]
    /*id="basic-button"
    aria-controls={open ? 'basic-menu' : undefined}*/, {
      "aria-haspopup": "true",
      "aria-expanded": open ? 'true' : undefined,
      onClick: handleClick,
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Menu["default"], {
      id: "basic-menu",
      anchorEl: anchor,
      open: open,
      onClose: handleClose,
      className: "menu",
      slotProps: {
        paper: {
          sx: {
            width: menuWidth // Définit la largeur du menu
          }
        }
      }
      /*MenuListProps={{
          'aria-labelledby': 'basic-button',
      }}*/,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
        onClick: function onClick(e) {
          return handleLink(e, "/projects");
        },
        className: "menu-link-text",
        children: "Projets"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
        onClick: function onClick(e) {
          return handleLink(e, "/scientific-articles");
        },
        className: "menu-link-text",
        children: "Articles scientifiques"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
        onClick: function onClick(e) {
          return handleLink(e, "/at-reports");
        },
        className: "menu-link-text",
        children: "Rapports internes"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
        onClick: function onClick(e) {
          return handleLink(e, "/treatment-types");
        },
        className: "menu-link-text",
        children: "Types de traitements"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
        onClick: function onClick(e) {
          return handleLink(e, "/varieties");
        },
        className: "menu-link-text",
        children: "Variet\xE9s"
      }), currentUser["role_name"] === "AT_ADMIN" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: function onClick(e) {
            return handleLink(e, "/categories");
          },
          className: "menu-link-text",
          children: "Cat\xE9gories"
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
        onClick: function onClick(e) {
          return handleLink(e, "/ptu-type-roles");
        },
        className: "menu-link-text",
        children: "Roles des types de PTU"
      })]
    })]
  });
}
var _default = exports["default"] = TabMenuRD;